export const SearchSubLabel = ({ text }: { text: string }) => {
  return (
    <div className="flex items-center justify-between mt-2 mb-4">
      <label className="font-header font-semibold text-gray50">{text}</label>
    </div>
  )
}
